import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__wrapper" }
const _hoisted_3 = { class: "footer__content" }
const _hoisted_4 = { class: "footer__apps" }
const _hoisted_5 = { class: "footer__apps-text" }
const _hoisted_6 = { class: "footer__apps-list" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "footer__content" }
const _hoisted_9 = { class: "footer__powered-by" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "https://sm-center.ru" }, " sm-center.ru ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import '@/layouts/SmFooter/style.scss'
import { useConfig } from '@/composables/config'
import { useI18n } from 'vue-i18n'
import SmMainMenu from '@/components/common/SmMainMenu/SmMainMenu.vue'
import SmIcon from '@/components/ui/SmIcon/SmIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SmFooter',
  setup(__props) {

const { getAppsLinks } = useConfig()

const appsList = getAppsLinks()

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SmMainMenu, { class: "footer__menu" }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('apps_text')), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appsList), (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `app-item-${i}`,
                class: "footer__apps-item"
              }, [
                _createElementVNode("a", {
                  href: item.href,
                  target: "_blank",
                  class: "footer__apps-link"
                }, [
                  _createVNode(SmIcon, {
                    name: item.icon,
                    title: item.name,
                    class: "footer__app-icon"
                  }, null, 8, ["name", "title"])
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, [
          _createTextVNode(_toDisplayString(_unref(t)('powered_by')) + " ", 1),
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_unref(t)('copyright')), 1)
        ])
      ])
    ])
  ]))
}
}

})